import React from 'react';
import {connect} from 'react-redux';
import {withRouter, RouteComponentProps} from 'react-router';

import {openModal} from 'ducks/modals';
import {MODALS} from 'ducks/users';

import SearchFilter from 'components/Filters/SearchFilter';
import Button from 'components/Button';

import './styles.css';

interface SubNavigationProps {
  filters: any;
  setFilter: (field, value) => void;
}

class SubNavigation extends React.Component<
  SubNavigationProps &
    RouteComponentProps<{locationRef: string}> &
    typeof mapDispatchToProps
> {
  openCreateMemberModal = () => {
    this.props.openModal(MODALS.CREATE_MEMBER);
  };

  openCreateUserModal = () => {
    this.props.openModal(MODALS.CREATE_USER);
  };

  render() {
    return (
      <div className="SubNavigation colab-sidepadding-2 colab-centered">
        <SearchFilter
          value={this.props.filters.search}
          onChange={(search: string) => this.props.setFilter('search', search)}
        />
        <Button white onClick={this.openCreateUserModal}>
          Create User
        </Button>
        <Button white onClick={this.openCreateMemberModal}>
          Create Member
        </Button>
      </div>
    );
  }
}

const mapDispatchToProps = {
  openModal
};

export default withRouter(
  connect(null, mapDispatchToProps)(SubNavigation)
) as React.ComponentType<SubNavigationProps>;
